import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { ApolloService } from '../services/apollo.service';


@Injectable({
  providedIn: 'root',
})
export class LngDataService {

 
  constructor(private apolloService: ApolloService) { }

  getLngData(filter: any) {
    const query = `
       query GetLngData($filter: LngDataFilter) {
        getLngData(filter: $filter) {
          success
          statusCode
          message
          hasOffHireinCurrentMonth
          hasOffHireinPreviousMonth
          data {
            vslCode
            vslNumber
            vslName
            vslOwner
            vslClass
            vslCodeOwner
            subPool
            opDays
            lngSavingsAmt
            opDaysYTD
            lngSavingsAmtYTD
            }
          }
        }
      `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getLngBunkerData(filter: any) {
    const query = `
      query getAvgBunkerPriceData($filter: AvgBunkerPriceFilterInput!) {
      getAvgBunkerPriceData(filter: $filter) {
        data {
          fiscalYear  
          year
          month
          monthNumber
          LNGCost
          LSFCost
          MGOCost
        }
        success
        statusCode
        message
      }
      }
      `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }

  getLngSavingsFormula(filter: any) {
    const query = `
     query GetFleetLevelLngSavings($filter: SubpoolFleetLevelLngSaving) {
        getFleetLevelLngSavings(filter: $filter) {
          data {
            lngSavingsMonthly
            lngSavingsYTD
            prevYearReconLngSavingsAmt
            prevYearReconLngSavingsAmtYTD 
          }
          success
          statusCode
          message
        }
      }
      `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }
 

}


